<template>
  <div>
    <basic-container>
      <div>
        <el-form :model="goodsForm">
          <!-- 产品名称 -->
          <el-form-item label="产品名称" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.name" placeholder="请输入产品名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品类型" style="display: flex;width:300px;">
            <el-input v-model.number="goodsForm.productType" placeholder="请输入产品类型" type="number" min="0"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="分组" style="display: flex;width:300px;">
            <el-input v-model.number="goodsForm.grouping" placeholder="请输入分组" type="number" min="0"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="单位" style="display: flex;width:300px;">
            <el-input v-model="goodsForm.unit" placeholder="请输入单位" clearable disabled></el-input>
          </el-form-item>
          <el-form-item label="产品属性" style="display: flex;width:300px;">
            <el-input v-model="calculateTypeText" placeholder="产品属性" clearable disabled></el-input>
          </el-form-item>
          <!-- 价格配置 -->
          <el-form-item label="价格配置">
            <el-table :data="goodsFormData" border style="width: 100%; margin-top: 20px">
              <el-table-column prop="sort" label="排序" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.sort" placeholder="请输入排序" type="number" min="1"
                    clearable></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="sku名称" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" placeholder="请输入名称" clearable></el-input>
                </template>
              </el-table-column>
              <!-- sku的value值 -->
              <el-table-column prop="value" label="sku值" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.value" placeholder="请输入值" clearable></el-input>
                </template>
              </el-table-column>
              <!-- 价格 -->
              <el-table-column prop="price" label="价格" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.price" placeholder="请输入价格" type="number" min="0"
                    clearable></el-input>
                </template>
              </el-table-column>
              <!-- 客户价格 -->
              <el-table-column prop="customerPrice" label="客户价格" min-width="150">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.customerPrice" placeholder="请输入客户价格" type="number" min="0"
                    clearable></el-input>
                </template>
              </el-table-column>
              <!-- 选择渠道：家装/装饰公司 -->
              <el-table-column prop="channel" label="渠道" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.channel" placeholder="请选择渠道" multiple clearable>
                    <el-option v-for="channel in channels" :key="channel.id" :label="channel.valueName"
                      :value="channel.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <!-- 位置：厨房/阳台/卫生间 -->
              <el-table-column prop="position" label="位置" min-width="150">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.position" placeholder="请选择位置" multiple clearable>
                    <el-option v-for="position in positions" :key="position.id" :label="position.valueName"
                      :value="position.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
      </div>
      <div style="width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px">
        <el-button type="danger" size="small" @click="goBack" icon="el-icon-circle-close-outline">返回</el-button>
      </div>
    </basic-container>
  </div>
</template>
<script>
import { updateGoods, getGoodsForm } from "@/api/work/ceiling/purWaterGoods";
import { DIC } from "@/const/dic";
import {
  findDataSourceFields,
  findDataSourceAll,
} from "@/api/work/dynamicForm";
export default {
  data() {
    return {
      calculateTypes: [
        { id: 1, valueName: '辅材' },
        { id: 2, valueName: '扣板' },
        { id: 3, valueName: '电器' }
      ],
      channels: [
        { id: 1, valueName: '家装渠道' },
        { id: 2, valueName: '分销渠道' }
      ],
      positions: [
        { id: 1, valueName: '厨房' },
        { id: 2, valueName: '阳台' },
        { id: 3, valueName: '卫生间' },
        { id: 4, valueName: '其他' }
      ],
      goodsForm: {
        name: '',
        type: '', // 添加type字段
        group: '', // 添加group字段
        id: '', // 添加id字段，用于提交时区分是新增还是修改
        calculateType: '', // 产品属性：1-辅材，2-主材，3-电器
        filters: [] // 存放从接口获取的原始数据
      },
      calculateTypeText: '',
      // productAttributeText 已废弃，使用 calculateTypeText 代替
      goodsFormData: [], // 用于编辑的临时数据
      formData: '',
      isPas: false,
      inputTypes: [],
      dataSources: [],
      agentIds: [],
      auditors: DIC.SERVICEITEM_AUDITOR,
      clientTypes: DIC.SERVICEITEM_TYPE,
      dynamicForm: {
        formName: '',
        formType: ''
      },
      dynamicTypes: [], // 确保这是一个数组
      dynamicFormData: [] // 确保这是一个数组
    };
  },
  created() {
    findDataSourceFields().then(res => {
      let data = JSON.parse(res.data);
      this.inputTypes = data;
    });
    findDataSourceAll().then(res => {
      let data = JSON.parse(res.data);
      this.dataSources = data.rows;
    });
    const goodsId = this.$route.query.GoodsId; // 假设产品ID通过路由参数传递
    if (goodsId) {
      this.fetchGoodsData(goodsId);
    }
  },
  watch: {
    'goodsForm.calculateType': function(newValue) {
      const attribute = this.calculateTypes.find(item => item.id == newValue);
      this.calculateTypeText = attribute ? attribute.valueName : '';
    }
  },
  methods: {
    fetchGoodsData(goodsId) {
      getGoodsForm(goodsId).then(res => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.goodsForm = data;
          // 设置产品属性文本
          const attribute = this.calculateTypes.find(item => item.id == data.calculateType);
          this.calculateTypeText = attribute ? attribute.valueName : '';
          this.goodsFormData = data.filters.map(filter => ({
            ...filter,
            customerPrice: filter.customerPrice || 0, // 确保客户价格字段存在
            // 渠道和位置是逗号分隔的字符串，需要转换为数组进行反显
            channel: filter.channel ? this.channels.filter(channel => filter.channel.split(',').includes(channel.id.toString())).map(channel => channel.id) : [],
            position: filter.position ? this.positions.filter(position => filter.position.split(',').includes(position.id.toString())).map(position => position.id) : []
          }));
          console.log('222', this.goodsFormData);

          /*  this.dynamicFormData = data.dynamicFormRequest.fields.map(field => ({
             id: field.id,
             dynamicId: field.dynamicId,
             deleteFlag: field.deleteFlag,
             createBy: field.createBy,
             createTime: field.createTime,
             updateBy: field.updateBy,
             updateTime: field.updateTime,
             fieldName: field.fieldName,
             inputType: this.formatInputType(field.inputType),
             dataSource: field.dataSource,
             isNull: field.isNull,
             sort: field.sort
           }));
           // 如果加载后的数据为空，添加一行默认数据 */
          if (this.goodsFormData.length === 0) {
            this.goodsFormData.push({
              name: '',
              type: '',
            });
          }
          /* if (this.dynamicFormData.length === 0) {
            this.dynamicFormData.push({
              fieldName: '',
              inputType: '',
              dataSource: '',
              isNull: '',
              sort: ''
            });
          } */
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    // 格式化inputType
    formatInputType(inputType) {
      // 将 inputType 转换为字符串类型
      const inputTypeString = String(inputType); // 使用 String 而不是 toString
      const matchedType = this.inputTypes.find(item => item.id == inputTypeString);
      return matchedType ? matchedType.name : ''; // 添加检查以防止未找到匹配项
    },
    goBack() {
      let item = {
        close: true,
        label: "编辑净水产品",
        value: "/work/ceiling/purWaterGoods/edit"
      };
      this.$store.commit("DEL_TAG", item);
      this.$router.go(-1);
    },
    submit() {
      const submitData = {
        ...this.goodsForm,
        filters: this.goodsFormData.map(filter => ({
          ...filter,
          // 渠道和位置是数组，需要转换为逗号分隔的字符串进行提交
          channel: filter.channel ? filter.channel.join(',') : '',
          position: filter.position ? filter.position.join(',') : '',
        }))

        /* dynamicFormRequest: {
          id: this.goodsForm.dynamicFormRequest.id || '', // 如果有 ID 则更新，否则添加
          name: this.goodsForm.dynamicFormRequest.formName,
          rootDepartId: this.goodsForm.dynamicFormRequest.rootDepartId || '', // 根据实际情况设置
          deleteFlag: this.goodsForm.dynamicFormRequest.deleteFlag || '', // 这个字段根据实际情况设置
          createBy: this.goodsForm.dynamicFormRequest.createBy || '', // 这个字段根据实际情况设置
          createTime: this.goodsForm.dynamicFormRequest.updateTime, // 使用当前时间戳
          updateBy: this.goodsForm.dynamicFormRequest.updateBy || null, // 根据实际情况设置
          updateTime: this.goodsForm.dynamicFormRequest.updateTime || null, // 根据实际情况设置
          fields: this.dynamicFormData.map(field => ({
            id: field.id || '', // 如果有 ID 则更新，否则添加
            dynamicId: field.dynamicId || '', // 根据实际情况设置
            fieldName: field.fieldName,
            inputType: this.inputTypes.find(inputType => inputType.name == field.inputType || inputType.id == field.inputType).id,
            dataSource: field.dataSource || '', // 根据实际情况设置
            isNull: field.isNull,
            sort: field.sort || '', // 根据实际情况设置
            deleteFlag: field.deleteFlag || '', // 这个字段根据实际情况设置
            createBy: field.createBy || '', // 这个字段根据实际情况设置
            createTime: field.updateTime, // 使用当前时间戳
            updateBy: field.updateBy || null, // 根据实际情况设置
            updateTime: field.updateTime || null // 根据实际情况设置
          }))
        } */
      };
      updateGoods(submitData).then(res => {
        if (res.code === "200") {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
          this.$store.commit('DEL_ALL_TAG')
          // 返回上一页
          this.$router.go(-1);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    handleSteppingDelete(index) {
      if (this.goodsFormData.length === 1) {
        this.$message({
          showClose: true,
          message: "动态产品不能为空",
          type: "error"
        });
      } else {
        this.goodsFormData.splice(index, 1);
      }
    },
    handleAddRows() {
      this.goodsFormData.push({
        name: '',
        time: '',
        unit: '',
      });
    },
    handleSteppingDelete1(index) {
      if (this.dynamicFormData.length == 1) {
        this.$message({
          showClose: true,
          message: "动态表单配置不能为空",
          type: "error"
        });
      } else {
        this.dynamicFormData.splice(index, 1);
      }
    },
    handleAddRows1() {
      this.dynamicFormData.push({
        fieldName: '',
        inputType: '',
        dataSource: '',
        isNull: '',
        sort: ''
      });
    }
  }
};
</script>

<style scoped></style>
